import React from 'react'

function Copyright() {
    return (
        <div>
          
            <div className="copyright">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <p className="p-small">Copyright © 2021 <a href="https://the-fountainhead.business.site/?m=true">TheFountainhead</a> - All rights reserved</p>
                        </div> 
                    </div> 
                </div> 
            </div> 
        </div>
    )
}

export default Copyright
